// extracted by mini-css-extract-plugin
export default {"btnDelete":"styles-module--btnDelete--SIAo3","btnViewPage":"styles-module--btnViewPage--JyDzu","headerIconClass":"styles-module--headerIconClass--4aHOH"};